var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import Store from './Store';
import { Wrapper } from '../components/wrapper';
import { resolvePosition } from '../utils/resolvePosition';
var root = {
    // top
    topRight: undefined,
    topCenter: undefined,
    topLeft: undefined,
    // bottom
    bottomRight: undefined,
    bottomCenter: undefined,
    bottomLeft: undefined
};
var StoreMessage = /** @class */ (function (_super) {
    __extends(StoreMessage, _super);
    function StoreMessage() {
        return _super.call(this) || this;
    }
    StoreMessage.prototype.render = function (position) {
        var _a;
        var positionClass = resolvePosition(position);
        var elm = document.querySelector(".wrapper-messages.".concat(positionClass));
        var instances = this.getInstances(position);
        if (!root[position]) {
            root[position] = createRoot((elm === null || elm === void 0 ? void 0 : elm.parentElement)
                ? elm.parentElement
                : document.body.appendChild(document.createElement('DIV')));
        }
        (_a = root[position]) === null || _a === void 0 ? void 0 : _a.render(React.createElement(Wrapper, { isMessage: true, position: position, instances: instances, onRemove: this.unsubscribe }));
    };
    return StoreMessage;
}(Store));
export default StoreMessage;
